import { FirebaseActions, FirebaseTypes } from '@web_opxp/features';

/**
 * firebase analytics action builders
 */

// 404 page visited
export const firebase404EventPayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'Error_page',
  parameters: [
    {
      key: 'Error_code',
      value: '404',
    },
  ],
};
export const firebase404VisitedAction: (url: string) => ReturnType<typeof FirebaseActions.analyticsEvent> = (url) => {
  const newParam: FirebaseTypes.IEventParam = {
    key: 'url',
    value: url,
  };
  !!firebase404EventPayload.parameters && firebase404EventPayload.parameters.push(newParam);
  return FirebaseActions.analyticsEvent(firebase404EventPayload);
};

// 401 event action
export const firebase401EventPayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'Error_page',
  parameters: [
    {
      key: 'Error_code',
      value: '401',
    },
  ],
};
export const firebase401EventAction: () => ReturnType<typeof FirebaseActions.analyticsEvent> = () => {
  return FirebaseActions.analyticsEvent(firebase401EventPayload);
};

// Unity not supported action
export const unityNotSupportedEventPayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'Error_page',
  parameters: [
    {
      key: 'Error_code',
      value: 'unity',
    },
  ],
};
export const unityNotSupportedEventAction: () => ReturnType<typeof FirebaseActions.analyticsEvent> = () => {
  return FirebaseActions.analyticsEvent(unityNotSupportedEventPayload);
};
